import { AuthService } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

export interface DataIntegrityCheckResult {
  categories: IntegrityCategory[];
  totalIssues: number;
  criticalCount: number;
  warningCount: number;
  infoCount: number;
  checkedAt: string;
}

export interface IntegrityCategory {
  name: string;
  description: string;
  severity: 'critical' | 'warning' | 'info';
  sourceTable: string;
  referencedTable: string;
  issues: IntegrityIssue[];
}

export interface IntegrityIssue {
  column: string;
  invalidValue: string;
  affectedRows: number;
  description: string;
  impact: string;
  exampleRecords: string[];
}

class DataIntegrityService {
  async validate(): Promise<DataIntegrityCheckResult> {
    const response = await AuthService.authenticatedGet(`${API_BASE_URL}/data-integrity/validate`);

    if (!response.ok) {
      throw new Error(`Dataintegritet-analyse feilet: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  }
}

export const dataIntegrityService = new DataIntegrityService();
